
import './App.css';
import Navbar from './Navbar';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Storyboard from './Storyboard';
import Profile from './Profile';
import Content1 from './Content1';
import Content2 from './Content2';
import Content3 from './Content3';
import Content4 from './Content4';
import Content5 from './Content5';
function App() {
  return (
    <>
    <div className='whole'>
  <Router>
       <Navbar />
       <Storyboard />
       <Profile />
       <Content1 />
       <Content2 />
       <Content3 />
       <Content4 />
       <Content5 />
       </Router></div>
       </>
  );
}

export default App;
